<template>
  <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
    <div id="TituloDetalleDeDocumento_div">
      <h5 class="label-black" style="margin-bottom: 0px;">DOCUMENTOS</h5>
      <h6 class="label-black" style="margin-top: 0px;">Inventario en Juzgado</h6>
    </div>

    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
        <div class="area custom-area">
          <Busqueda v-on:ValorDeConsulta="ObtenDatos($event)" :barCode= this.CodigoEnvio :actualiza= this.ActualizaConsulta />
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" v-if="Documento.BaseDatos.BaseDatosId==1">
        <div class="area custom-area" v-if="Documento.TipoDocumento.TipoDocumentoId==1 && IncidenteInfo==null && TerceriaInfo==null">
          <div>
            <h6 class="label-black">Datos Principales</h6>
            <hr>
          </div>
          <div class="row align-items-center">
            <div class="form-group col-8" id="Area_div">
              <label class="label-black">Área</label>
              <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
            </div>
            <div class="form-group col-4" id="Materia_div">
              <label class="label-black">Materia</label>
              <div v-if="Documento.Materia != null">
                <input type="text" class="form-control" v-model="Documento.Materia.Nombre" readonly />
              </div>
              <div v-else>
                <input type="text" class="form-control" readonly />
              </div>
            </div>

          </div>
          <div class="row align-items-center">
            <div class="form-group col-4" id="TipoDocumento_div">
              <label class="label-black">Tipo de Documento</label>
              <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
            </div>
            <div class="form-group col-4" id="Anio_div">
              <label class="label-black">Año</label>

              <input type="text" class="form-control " v-model="Documento.Anio" readonly />
            </div>
            <div class="form-group col-4" id="Consecutivo_div">
              <label class="label-black">Consecutivo</label>
              <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
            </div>
          </div>
          <div class="row align-items-center" v-if="Documento.FechaRegistroArchivo!=null">
            <div class="form-group col-4" id="TipoDocumento_div">
              <label class="label-black">Fecha de Registro En Archivo Judicial</label>
              <input type="text" class="form-control" v-model="Documento.FechaRegistroArchivo" readonly />
            </div>
          </div>
          <div class="row align-items-center" v-if="Documento.Anexos!=null">
            <div class="form-group col-12" id="TipoDocumento_div">
              <label class="label-black">Observaciones y/o Anexos</label>
              <input type="text" class="form-control" v-model="Documento.Anexos" readonly />
            </div>
          </div>
          <div v-if="Documento.Referencias.length>0">
            <h6 class="text-success">Documentos Relacionados</h6>
            <hr>
            <ul >
              <li v-for="elemento in Documento.Referencias">
                <span>{{elemento.Referencia.Area.Nombre}},&nbsp;&nbsp;&nbsp;documento: {{elemento.Referencia.Consecutivo}}/{{elemento.Referencia.Anio}},&nbsp;&nbsp;&nbsp; relación por: {{elemento.TipoReferencia.Nombre}}</span>
              </li>
            </ul>
          </div>
          <div v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0 && (Documento.TipoDocumento.TipoDocumentoId!=23 && Documento.TipoDocumento.TipoDocumentoId!=24) && (Documento.Area.AreaId!=11 && Documento.Area.AreaId!=12 && Documento.Area.AreaId!=13 && Documento.Area.AreaId!=14 && Documento.Area.AreaId!=15 && Documento.Area.AreaId!=16)">
                <h6 class="label-black">Datos del Juicio</h6>
                <hr>
              </div>
          <div class="row" v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0 && (Documento.TipoDocumento.TipoDocumentoId!=23 && Documento.TipoDocumento.TipoDocumentoId!=24) && (Documento.Area.AreaId!=11 && Documento.Area.AreaId!=12 && Documento.Area.AreaId!=13 && Documento.Area.AreaId!=14 && Documento.Area.AreaId!=15 && Documento.Area.AreaId!=16)">
            <div class="form-group col-2" id="Estatus_div">
              <label class="label-black">Tipo:</label>
            </div>
            <div class="form-group col-4" id="Estatus_div">
              <label class="label-black">{{Documento.Juicio.Juicio}}</label>
            </div>
            <div class="form-group col-2" id="Estatus_div">
              <label class="label-black">Tramite:</label>
            </div>
            <div class="form-group col-4" id="Estatus_div">
              <label class="label-black">{{Documento.Juicio.Tramite}}</label>
            </div>
          </div>

          <div>
            <h6 class="label-black">Datos de las Partes</h6>
          </div>
          <div id="Partes_table" class="table-responsive">
            <table class="table table-striped table-light table-hover table-sm">
              <thead class="thead-custom">
                <tr>
                  <th>Parte</th>
                  <th>Nombre</th>
                </tr>
              </thead>
              <tbody class="text-dark">
                <tr v-if="Documento.Partes.length <= 0">
                  <td colspan="12" class="text-center">No hay registro Partes</td>
                </tr>
                <tr v-else v-for="parte in Documento.Partes" :key="parte.Documento_Referencia">
                  <td>{{parte.Tipo_Parte}}</td>
                  <td>{{parte.Nombre}} {{parte.ApellidoPaterno}} {{parte.ApellidoMaterno}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div >
              <h6 class="label-black">Tomos del Documento</h6>
          </div>
          <div id="Volumen_table" class="table-responsive">
            <table class="table table-striped table-light table-hover table-sm">
              <thead class="thead-custom">
                <tr>
                  <th>No.</th>
                  
                  <th>Ubicación</th>
                  <th>Contenido</th>
                </tr>
              </thead>
              <tbody class="text-dark">
                <tr v-if="Documento.Volumenes.length <= 0">
                  <td colspan="12" class="text-center">No hay registro del Volumen</td>
                </tr>
                <tr v-else v-for="detalle in Documento.Volumenes" :key="detalle.VolumenId">
                  <td width="90">{{detalle.NumVolumen}}</td>
                  <td width="400" v-html="DetallesUbicacionVolumen(detalle, Documento.SedeArchivo)"></td>
                  <!-- <td width="300" v-if="detalle.MovimientoVolumen.FechaRecepcion!=null">Área: {{detalle.Area.Nombre}}, <br/>Usuario: {{detalle.MovimientoVolumen.UsuarioQuienRecibe.Nombre}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno}} <br/>Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoVolumen.FechaMovimiento)}}</td>
                  <td width="300" v-else-if="detalle.MovimientoVolumen.AreaExterna==null">
                    {{detalle.MovimientoVolumen.AreaQuePresta.Nombre}}, <br/>Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoVolumen.FechaMovimiento)}}<br/>
                    Pendiente de Recepción por : <br>{{detalle.MovimientoVolumen.UsuarioQuienRecibe!=null ? detalle.MovimientoVolumen.UsuarioQuienRecibe.Nombre : ""}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe!=null ? detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno : ""}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe!=null ? detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno : ""}}
                  </td>
                  <td width="300" v-else  v-html="DetallesExternos(detalle.MovimientoVolumen)"></td> -->
                  <td width="600" v-html="DesglosaContenido(detalle, Documento.Materia.MateriaId)"></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="Documento.Incidentes.length>0 && Documento.Materia.MateriaId!=3">
              <h6 class="label-black">Incidentes del Documento</h6>
          </div>
          <div id="Incidentes_table" class="table-responsive" v-if="Documento.Incidentes.length>0 && Documento.Materia.MateriaId!=3">
                  <table class="table table-striped table-light table-hover table-sm">
                    <thead class="thead-custom">
                      <tr>
                        <th>No.</th>
                        <th>Tipo Incidente</th>
                        <th>Ubicacion</th>
                        
                      </tr>
                    </thead>
                    <tbody class="text-dark">
                      <tr v-if="Documento.Incidentes.length <= 0">
                        <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                      </tr>
                      <tr v-else v-for="detalle in Documento.Incidentes" :key="detalle.IncidenteId">
                        <td width="50">{{detalle.NumeroIncidente}}</td>
                        <td width="180">{{detalle.TipoIncidente}}</td>
                        <td width="400" v-html="DetallesUbicacionIncidente(detalle, Documento.SedeArchivo)"></td>
                        <!-- <td width="300" v-if="detalle.MovimientoIncidente.FechaRecepcion!=null">Área: {{detalle.Area.Nombre}}, <br/>Usuario: {{detalle.MovimientoIncidente.UsuarioQuienRecibe.Nombre}} {{detalle.MovimientoIncidente.UsuarioQuienRecibe.ApellidoPaterno}} {{detalle.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno}}<br/>Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoIncidente.FechaMovimiento)}}</td>
                        <td width="300" v-else-if="detalle.MovimientoIncidente.AreaExterna==null">
                          {{detalle.MovimientoIncidente.AreaQuePresta.Nombre}}, <br/>Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoIncidente.FechaMovimiento)}}<br/>
                          Pendiente de Recepción por : <br/>{{detalle.MovimientoIncidente.UsuarioQuienRecibe.Nombre}} {{detalle.MovimientoIncidente.UsuarioQuienRecibe.ApellidoPaterno}} {{detalle.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno}}
                        </td>
                        <td width="300" v-else v-html="DetallesExternos(detalle.MovimientoIncidente)"></td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
          <div v-if="Documento.Tercerias.length>0">
                  <h6 class="label-black">Tercerías</h6>
                </div>
          <div id="Tercerias_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Tercerias.length>0">
                  <table class="table table-striped table-light table-hover table-sm">
                    <thead class="thead-custom">
                      <tr>
                        <th>No.</th>
                        <th>Tipo Terceria</th>
                        <th>Ubicacion</th>
                      </tr>
                    </thead>
                    <tbody class="text-dark">
                      <tr v-if="Documento.Tercerias.length <= 0">
                        <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                      </tr>
                      <tr v-else v-for="detalle in Documento.Tercerias" :key="detalle.TerceriaId">
                        <td width="50">{{detalle.NumeroTerceria}}</td>
                        <td width="150">{{detalle.TipoTerceria}}</td>
                        <td width="400" v-html="DetallesUbicacionTerceria(detalle, Documento.SedeArchivo)"></td>
                        <!-- <td width="300" v-if="detalle.MovimientoTerceria.FechaRecepcion!=null">{{detalle.Area.Nombre}}, Usuario: {{detalle.MovimientoTerceria.UsuarioQuienRecibe.Nombre}} {{detalle.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno}} {{detalle.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno}}<br/>Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoTerceria.FechaMovimiento)}}</td>
                        <td width="300" v-else-if="detalle.MovimientoTerceria.AreaExterna==null">
                          {{detalle.MovimientoTerceria.AreaQuePresta.Nombre}}, Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoTerceria.FechaMovimiento)}}<br/>
                          Pendiente de Recepción por : <br/>{{detalle.MovimientoTerceria.UsuarioQuienRecibe.Nombre}} {{detalle.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno}} {{detalle.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno}}
                        </td>
                        <td width="300" v-else v-html="DetallesExternos(detalle.MovimientoTerceria)"></td> -->
                      </tr>
                    </tbody>
                  </table>
          </div>

        </div>
        <!-- <-- Aqui -->
        <div class="area custom-area" v-if="Documento.TipoDocumento.TipoDocumentoId==4">
          <div>
            <h6 class="label-black">Datos Principales</h6>
            <hr>
          </div>
          <div class="row align-items-center">
            <div class="form-group col-8" id="Area_div">
              <label class="label-black">Área</label>
              <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
            </div>
            <div class="form-group col-4" id="TipoDocumento_div">
              <label class="label-black">Tipo de Documento</label>
              <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
            </div>
          </div>
          <div class="row align-items-center">
            <div class="form-group col-4" id="Anio_div">
              <label class="label-black">Año</label>
              <input type="text" class="form-control " v-model="Documento.Anio" readonly />
            </div>
            <div class="form-group col-4" id="Consecutivo_div" v-if="Documento.Sufijo==null">
              <label class="label-black">Consecutivo</label>
              <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
            </div>
            <div class="form-group col-2" id="Consecutivo_div" v-else>
              <label class="label-black">Consecutivo</label>
              <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
            </div>
            <div class="form-group col-4" id="Registro_div">
              <label class="label-black">Registro de creación</label>
              <input type="text" class="form-control" v-model="FechaCreacion" readonly />
            </div>

          </div>
          <div class="row align-items-center" v-if="Documento.AmparoDocumentoPrincipal!=null">
            <div class="form-group col-12" id="Estatus_div">
              <label class="text-success"><b>Amparo del Documento {{Documento.AmparoDocumentoPrincipal.TipoDocumento.Nombre}} {{Documento.AmparoDocumentoPrincipal.Consecutivo}}/{{Documento.AmparoDocumentoPrincipal.Anio}} del {{Documento.AmparoDocumentoPrincipal.Area.Nombre}}</b></label>
            </div>
          </div>
          
          <div>
            <div id="Amparos_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Volumenes.length>0 && Documento.AmparoDocumentoPrincipal==null">
                  <table class="table table-striped table-light table-hover table-sm">
                    <thead class="thead-custom">
                      <tr>
                        <th>Ubicación</th>
                      </tr>
                    </thead>
                    <tbody class="text-dark">
                      <tr v-if="Documento.Volumenes.length <= 0">
                        <td colspan="12" class="text-center">No hay registro del Volumen</td>
                      </tr>
                      <tr v-else v-for="detalle in Documento.Volumenes" :key="detalle.VolumenId">
                        <td width="300" v-if="detalle.MovimientoVolumen.FechaRecepcion!=null">{{detalle.Area.Nombre}} <br/>Usuario : {{detalle.MovimientoVolumen.UsuarioQuienRecibe.Nombre}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno}}<br/>Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoVolumen.FechaMovimiento)}}</td>
                        <td width="300" v-else-if="detalle.MovimientoVolumen.AreaExterna==null">
                          {{detalle.MovimientoVolumen.AreaQuePresta.Nombre}}, Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoVolumen.FechaMovimiento)}} <br/>
                          Pendiente de Recepción por : <br/> {{detalle.MovimientoVolumen.UsuarioQuienRecibe.Nombre}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno}}
                        </td>
                        <td width="300" v-else>
                          {{detalle.MovimientoVolumen.AreaExterna.Nombre}}, Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoVolumen.FechaMovimiento)}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  
                </div>
          </div>
        </div>
        <div class="area custom-area" v-if="Documento.TipoDocumento.TipoDocumentoId==5 || Documento.TipoDocumento.TipoDocumentoId==6 || Documento.TipoDocumento.TipoDocumentoId==11 || Documento.TipoDocumento.TipoDocumentoId==12">
          <div>
            <h6 class="label-black">Datos Principales</h6>
            <hr>
          </div>
          <div class="row align-items-center">
            <div class="form-group col-8" id="Area_div">
              <label class="label-black">Área</label>
              <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
            </div>
            <div class="form-group col-4" id="TipoDocumento_div">
              <label class="label-black">Tipo de Documento</label>
              <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
            </div>
          </div>
          <div class="row align-items-center">
            <div class="form-group col-4" id="Anio_div">
              <label class="label-black">Año</label>
              <input type="text" class="form-control " v-model="Documento.Anio" readonly />
            </div>
            <div class="form-group col-4" id="Consecutivo_div" v-if="Documento.Sufijo==null">
              <label class="label-black">Consecutivo</label>
              <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
            </div>
            <div class="form-group col-2" id="Consecutivo_div" v-else>
              <label class="label-black">Consecutivo</label>
              <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
            </div>
            <div class="form-group col-4" id="Registro_div">
              <label class="label-black">Registro de creación</label>
              <input type="text" class="form-control" v-model="FechaCreacion" readonly />
            </div>
          </div>
          <div >
              <h6 class="label-black">Tomos del Documento</h6>
          </div>
          <div id="Volumen_table" class="table-responsive">
            <table class="table table-striped table-light table-hover table-sm">
              <thead class="thead-custom">
                <tr>
                  <th>No.</th>
                  <th>Ubicación</th>
                  <th>Contenido</th>
                </tr>
              </thead>
              <tbody class="text-dark">
                <tr v-if="Documento.Volumenes.length <= 0">
                  <td colspan="12" class="text-center">No hay registro del Volumen</td>
                </tr>
                <tr v-else v-for="detalle in Documento.Volumenes" :key="detalle.VolumenId">
                  <td width="90">{{detalle.NumVolumen}}</td>
                  <td width="300" v-if="detalle.MovimientoVolumen.FechaRecepcion!=null">Área: {{detalle.Area.Nombre}}, <br/>Usuario: {{detalle.MovimientoVolumen.UsuarioQuienRecibe.Nombre}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno}} <br/>Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoVolumen.FechaMovimiento)}}</td>
                  <td width="300" v-else-if="detalle.MovimientoVolumen.AreaExterna==null">
                          {{detalle.MovimientoVolumen.AreaQuePresta.Nombre}}, Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoVolumen.FechaMovimiento)}} <br/>
                          Pendiente de Recepción por : <br/> {{detalle.MovimientoVolumen.UsuarioQuienRecibe.Nombre}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno}} {{detalle.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno}}
                  </td>
                  <td width="300" v-else>
                          {{detalle.MovimientoVolumen.AreaExterna.Nombre}}, Fecha de Envío: {{obtenFechaConFormato(detalle.MovimientoVolumen.FechaMovimiento)}}
                  </td>
                  <td width="600" v-html="DesglosaContenido(detalle, Documento.Materia.MateriaId)"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="area custom-area" v-if="IncidenteInfo!=null && (IncidenteInfo.IncidenteId>0 || IncidenteInfo.DocumentoId_Referencia>0)">
          <div>
            <h6 class="label-black">Datos Principales</h6>
            <hr>
          </div>
          <div class="row align-items-center">
            <div class="form-group col-4" id="Area_div">
              <label class="label-black">Incidente No:</label>
              <input type="text" class="form-control" v-model="IncidenteInfo.NumeroIncidente" readonly />
            </div>
            <div class="form-group col-8" id="TipoDocumento_div">
              <label class="label-black">Tipo de Incidente</label>
              <input type="text" class="form-control" v-model="IncidenteInfo.TipoIncidente" readonly />
            </div>
          </div>
          <div class="row align-items-center">
            <div class="form-group col-12" id="Area_div">
              <label class="text-success"><b>Incidente del {{Documento.TipoDocumento.Nombre}} {{Documento.Consecutivo}}/{{Documento.Anio}} de {{Documento.Area.Nombre}}</b></label>
              
            </div>
          </div>
        </div> 
        <div class="area custom-area" v-if="TerceriaInfo!=null && TerceriaInfo.TerceriaId>0">
          <div>
            <h6 class="label-black">Datos Principales</h6>
            <hr>
          </div>
          <div class="row align-items-center">
            <div class="form-group col-4" id="Area_div">
              <label class="label-black">Tercería No:</label>
              <input type="text" class="form-control" v-model="TerceriaInfo.NumeroTerceria" readonly />
            </div>
            <div class="form-group col-8" id="TipoDocumento_div">
              <label class="label-black">Tipo de Tercería:</label>
              <input type="text" class="form-control" v-model="TerceriaInfo.TipoTerceria" readonly />
            </div>
          </div>
          <div class="row align-items-center">
            <div class="form-group col-12" id="Area_div">
              <label class="text-success"><b>Tercería del {{Documento.TipoDocumento.Nombre}} {{Documento.Consecutivo}}/{{Documento.Anio}} de {{Documento.Area.Nombre}}</b></label>
              
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" v-if="Documento.BaseDatos.BaseDatosId==2 || Documento.BaseDatos.BaseDatosId==3">
        <div class="area custom-area">
          <div>
            <h5 class="label-black">Información Principal</h5>
            <hr>
          </div>
          <div>
            <div class="row align-items-center">
              <div class="form-group col-8" id="Area_div">
                <label class="label-black">Área</label>
                <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
              </div>
              <div class="form-group col-4" id="Materia_div" v-if="Documento.Materia != null">
                <label class="label-black">Materia</label>
                <input type="text" class="form-control" v-model="Documento.Materia.Nombre" readonly />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-4" id="TipoDocumento_div">
                <label class="label-black">Tipo de Documento</label>
                <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
              </div>
              <div class="form-group col-4" id="Anio_div">
                <label class="label-black">Año</label>
                <input type="text" class="form-control " v-model="Documento.Anio" readonly />
              </div>
              <div class="form-group col-4" id="Consecutivo_div" v-if="Documento.Sufijo==null">
                <label class="label-black">Consecutivo</label>
                <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
              </div>
              <div class="form-group col-2" id="Consecutivo_div" v-else>
                <label class="label-black">Consecutivo</label>
                <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
              </div>
              <div class="form-group col-2" id="Consecutivo_div" v-if="Documento.Sufijo!=null">
                <label class="label-black">Sufijo</label>
                <input type="text" class="form-control" v-model="Documento.Sufijo" readonly />
              </div>
            </div>
        
          </div>
          <div v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0 && (Documento.TipoDocumento.TipoDocumentoId!=23 && Documento.TipoDocumento.TipoDocumentoId!=24) && (Documento.Area.AreaId<=12 && Documento.Area.AreaId>=16)">
                <h5 class="label-black">Información del Juicio</h5>
                <hr>
          </div>
          <div class="row" v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0 && (Documento.TipoDocumento.TipoDocumentoId!=23 && Documento.TipoDocumento.TipoDocumentoId!=24) && (Documento.Area.AreaId<=12 && Documento.Area.AreaId>=16)">
            <div class="form-group col-1" id="Estatus_div">
              <label class="label-black"><b>Tipo:</b></label>
            </div>
            <div class="form-group col-5" id="Estatus_div">
              <label class="label-black">{{Documento.Juicio.Juicio}}</label>
            </div>
            <div class="form-group col-1" id="Estatus_div">
              <label class="label-black"><b>Tramite:</b></label>
            </div>
            <div class="form-group col-5" id="Estatus_div">
              <label class="label-black">{{Documento.Juicio.Tramite}}</label>
            </div>
          </div>
          <div v-if="Documento.Partes!=null && Documento.Partes.length>0">
            <div>
              <h5 class="label-black">Información de las Partes</h5>
              <hr>
            </div>
            <div id="Partes_table" class="table-responsive">
              <table class="table table-striped table-light table-hover table-sm">
                <thead class="thead-custom">
                  <tr>
                    <th>Parte</th>
                    <th>Nombre</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-for="parte in Documento.Partes" :key="parte.Documento_Referencia">
                    <td>{{parte.Tipo_Parte}}</td>
                    <td>{{parte.Nombre}} {{parte.ApellidoPaterno}} {{parte.ApellidoMaterno}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if='Documento.InventarioDocumentoId> 0'>
                <div v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                    <h5 class="label-black">Contenido</h5>
                    <hr>
                </div>
                <div v-if="Documento.Volumenes!=null && Documento.Volumenes.length>0">
                  <div>
                    <h6 class="label-black">Tomos</h6>
                  </div>
                  <div id="Volumen_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Volumenes.length>0">
                  <table class="table table-striped table-light table-hover table-sm">
                    <thead class="thead-custom">
                      <tr>
                        <th>No.</th>
                        <th>Fojas</th>
                        <th>Ubicación</th>
                        <th>Contenido</th>
                        
                      </tr>
                    </thead>
                    <tbody class="text-dark">
                      <tr v-if="Documento.Volumenes.length <= 0">
                        <td colspan="12" class="text-center">No hay registro del Volumen</td>
                      </tr>
                      <tr v-else v-for="detalle in Documento.Volumenes" :key="detalle.VolumenId">
                        <td width="30">{{detalle.NumVolumen}}</td>
                        <td width="50">{{detalle.Fojas}}</td>
                        <td width="250" v-if="detalle.Area.AreaId ==21">{{detalle.Area.Nombre}} - {{Documento.SedeArchivo.Nombre}}</td>
                        <td width="250" v-else>{{detalle.Area.Nombre}}</td>
                        <td width="400" v-html="DesglosaContenido(detalle)"></td>
                      </tr>
                    </tbody>
                  </table>
                  
                </div>
                </div>
                <div v-if="Documento.Incidentes!=null && Documento.Incidentes.length>0">
                  <div>
                    <h6 class="label-black">Incidentes</h6>
                  </div>
                  <div id="Incidentes_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Incidentes.length>0">
                    <table class="table table-striped table-light table-hover table-sm">
                      <thead class="thead-custom">
                        <tr>
                          <th>No.</th>
                          <th>Tipo Incidente</th>
                          <th>Ubicacion</th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr v-if="Documento.Incidentes.length <= 0">
                          <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                        </tr>
                        <tr v-else v-for="detalle in Documento.Incidentes" :key="detalle.IncidenteId">
                          <td width="50">{{detalle.NumeroIncidente}}</td>
                          <td width="280">{{detalle.TipoIncidente}}</td>
                          <td width="400" v-if="detalle.Area.AreaId ==21">{{detalle.Area.Nombre}} - {{Documento.SedeArchivo.Nombre}}</td>
                          <td width="400" v-else>{{detalle.Area.Nombre}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div v-if="Documento.Tercerias!= null && Documento.Tercerias.length>0">
                  <div>
                    <h6 class="label-black">Tercerías</h6>
                  </div>
                  <div id="Tercerias_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Tercerias.length>0">
                    <table class="table table-striped table-light table-hover table-sm">
                      <thead class="thead-custom">
                        <tr>
                          <th>No.</th>
                          <th>Tipo Terceria</th>
                          <th>Ubicacion</th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr v-if="Documento.Tercerias.length <= 0">
                          <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                        </tr>
                        <tr v-else v-for="detalle in Documento.Tercerias" :key="detalle.TerceriaId">
                          <td width="50">{{detalle.NumeroTerceria}}</td>
                          <td width="280">{{detalle.TipoTerceria}}</td>
                          <td width="400" v-if="detalle.Area.AreaId ==21">{{detalle.Area.Nombre}} - {{Documento.SedeArchivo.Nombre}}</td>
                          <td width="400" v-else>{{detalle.Area.Nombre}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
          </div>
        </div>
      </div>

      <div v-if="this.ModalRef==true">
        <DocumentoDeReferencia :DatosReferencia= this.ReferenciaDoc @dialogo='EstatusModal($event)'>
        </DocumentoDeReferencia>
      </div >
      <div v-if="this.AddModalRef==true">
        <AgregaReferenciaModal :DocumentoPrincipal= this.Documento @dialogo='AddEstatusModal($event)'>
        </AgregaReferenciaModal>
      </div >
    </div>
    
  </div>

</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import FiltroDeBusqueda from '@/components/ArchivoJudicial/Comun/ConsultaDocumento.vue'
import AddReferencia from '@/components/ArchivoJudicial/Comun/ModalReferencia.vue'
import Documento_Referencia from '@/components/ArchivoJudicial/Comun/ReferenciaModal.vue'


export default {
    components:{
        Busqueda: FiltroDeBusqueda,
        AgregaReferenciaModal: AddReferencia,
        DocumentoDeReferencia: Documento_Referencia,
    },
    data(){
        return{
            enumeraciones,
            Documento: {
                InventarioDocumentoId: "",
                Area: {},
                Materia: {},
                TipoDocumento: {},
                Año: "",
                Consecutivo: "",
                CodigodeBarras: "",
                FechaRegistro: null,
                FechaRegistroArchivo: null,
                TipoEstatusInventario: {},
                SedeArchivo:{},
                //Estatus: {},
                Volumenes :[],
                Partes: [],
                Referencias: [],
                Incidentes:[],
                Tercerias:[],
                BaseDatos: {BaseDatosId : 0},
                Sufijo: null
                },
            ReferenciaDoc: [],
            ActualizaConsulta:{
                type: Boolean,
                default: false,
            },
            ModalRef: false,
            AddModalRef: false,
            CodigoEnvio: "",
            InfoDoc :{
                InventarioDocumentoId: "",
                Area: {},
                Materia: {},
                TipoDocumento: {},
                Año: "",
                Consecutivo: "",
            },
            IncidenteInfo: {},
            TerceriaInfo: {},
            FechaCreacion: null,
            FechaArchivado: null,
            porRecibir :[]
        }
    },
    props: {
        barraCode: {
            type: String,
            default: ""
        },
        RegresoInventario: false
    },
    methods:{
        obtenFechaConFormato: function(fechaRegistro) {
        return moment(fechaRegistro).format("DD-MM-YYYY");
        },
        ObtenDatos(datos){
            //verificamos si esta en juzgado que consulta
            if(this.VerificarUbicacion(datos.DocumentoConsulta.Volumenes, datos.DocumentoConsulta.Area.AreaId))
            {
                var fechaEnvio ="";
                if(datos.DocumentoConsulta.Volumenes[0].MovimientoVolumen!=null)
                {
                  fechaEnvio= moment(datos.DocumentoConsulta.Volumenes[0].MovimientoVolumen.FechaMovimiento).format('DD/MM/YYYY');
                }
                else
                {
                  fechaEnvio= datos.DocumentoConsulta.FechaRegistroArchivo!=null ? moment(datos.DocumentoConsulta.FechaRegistroArchivo).format('DD/MM/YYYY'): "No determinada";
                }
                var mensaje = "El Documento no se encuentra físicamente en " + datos.DocumentoConsulta.Area.Alias;
                if (datos.DocumentoReferenciado!= null)
                {
                  mensaje= mensaje +"</br> Este documento es referencia del " + datos.DocumentoReferenciado.TipoDocumento.Nombre + ", " + datos.DocumentoReferenciado.Consecutivo +"/"+ datos.DocumentoReferenciado.Anio +
                                  "</br> del " + datos.DocumentoReferenciado.Area.Alias;
                }
                else
                {
                  mensaje= mensaje + "</br> Ubicación Actual: " + datos.DocumentoConsulta.Volumenes[0].Area.Nombre;
                  mensaje= mensaje + "</br> Fecha de Envío: " + fechaEnvio;
                  if(datos.DocumentoConsulta.SolicitudActualTramite!=null)
                  {
                          //console.log(this.Documento.SolicitudActualTramite)
                    mensaje = mensaje +'</br><label class="text-warning">Este documento tiene una solicitud de prestamo en tramite.</label></br>Solicitado el: '  + this.obtenFechaConFormato(datos.DocumentoConsulta.SolicitudActualTramite.FechaRegistro);
                  }
                }
                
                
                comun.mensajeDeAlerta(mensaje, null, null);
            }
            else
            {
              
              this.Documento = datos.DocumentoConsulta;
              this.InfoDoc = datos.DocumentoReferenciado;
              this.IncidenteInfo = datos.InfoIncidente !=null ? datos.InfoIncidente: null;
              this.TerceriaInfo = datos.InfoTerceria !=null ? datos.InfoTerceria : null;
              this.Documento.FechaRegistro = moment(datos.DocumentoConsulta.FechaRegistro).format("DD-MM-YYYY");
              this.Documento.FechaRegistroArchivo = datos.DocumentoConsulta.FechaRegistroArchivo!=null ? moment(datos.DocumentoConsulta.FechaRegistroArchivo).format("DD-MM-YYYY"): null;
              this.FechaCreacion = this.Documento!=null? this.Documento.FechaRegistro : null;
              // this.FechaArchivado = this.Documento!=null? moment(this.Documento.FechaRegistroArchivo).format("DD-MM-YYYY"):null;
              this.CodigoEnvio = datos.CodigoBarras;
              if(datos.Listado!=null)
              {
                comun.mensajeDeAlerta('<label class="text-warning">Este Documento esta registrado en listado de Archivo' + (datos.Listado.Devolucion==false? ' Nuevo Ingreso ' : ' Devueltos ' ) + '<br/>Fecha de Envio pendiente : ' + this.obtenFechaConFormato(datos.Listado.FechaEnvio) + '</label>', null, null);
              };
              this.PorRecibir= this.AlertaRecepcion(datos.DocumentoConsulta.Volumenes);
              if(this.PorRecibir.length>0)
              {
                comun.mensajeDeAlerta('</br><label class="text-warning">Ubicación Actual : ' + this.PorRecibir[0].Ubicacion + '.</label></br><label class="text-warning">Este documento esta en proceso de Recepción por : ' + this.PorRecibir[0].Destino + '.</label></br>Enviado el: '  + this.PorRecibir[0].FechaEnvio, null, null);
              }
            }          
        },
        VaciaDatos(){
            this.Documento.InventarioDocumentoId = "";
            this.Documento.Area = "";
            this.Documento.Materia = "";
            this.Documento.TipoDocumento = "";
            this.Documento.Año = "";
            this.Documento.Consecutivo = "";
            this.Documento.CodigodeBarras = "";
            this.Documento.Fecha_Registro = "";
            this.Documento.Estatus = "";
            this.Volumenes = [];
            this.Partes = [];
        },
        VerReferencia(referencias){
          this.ReferenciaDoc = referencias;
          this.ModalRef = true;
        },
        EstatusModal(valor){
            this.ModalRef = valor;
        },
        AddEstatusModal(valor){
            this.AddModalRef = valor;
            this.ActualizaConsulta = true;
        },
        AgregaReferencia(referencias){
            this.AddModalRef = true;
            this.ActualizaConsulta = false;
        },
        VerificarUbicacion(volumenes, areaId){
          let cantidadNoEnArea = 0;
          $.each(volumenes, function(index, ubicacion)
          {
            
            if(areaId != ubicacion.Area.AreaId)
            {
              cantidadNoEnArea += 1;
            }
            
          });
          if(cantidadNoEnArea>0)
          {
            return true;
          }
          else {
            return false;
          }
        },
        DesglosaContenido: function (datos, materia){
            let Contenido ="";

            // if(datos.AnexosVolumen!=null && datos.AnexosVolumen.length>0)
            // {
            //     Contenido= Contenido +"<b class='text-primary'>ANEXOS</b><br/>";
            //         $.each(datos.AnexosVolumen, function(index, enVolumen)
            //         {
            //         Contenido = Contenido + "Cantidad: "+ enVolumen.Cantidad + ",  Observaciones: " + enVolumen.Observaciones + "<br/>";
            //         })
            // };
            if(datos.Amparos!=null && datos.Amparos.length>0)
            {
              Contenido= Contenido +"<b class='text-primary'>AMPAROS</b><br/>";
                    $.each(datos.Amparos, function(index, enVolumen)
                    {
                    Contenido = Contenido + enVolumen.AmparosDelDocumento.Consecutivo +"/" + enVolumen.AmparosDelDocumento.Anio + "<br/>";
                    })
            };
            
            if(datos.IncidenteVolumen!=null && datos.IncidenteVolumen.length>0)
                {
                  Contenido = Contenido +"<b class='text-primary'>INCIDENTES</b><br/>";
                    $.each(datos.IncidenteVolumen, function(index, enVolumen)
                    {
                    Contenido = Contenido + "No: "+ enVolumen.NumeroIncidente + ",  Tipo: " + enVolumen.TipoIncidente + "<br/>";
                    });
                  if(materia==3)
                  {
                    $.each(this.Documento.Incidentes, function(index, incidente)
                    {
                      Contenido = Contenido + "No: "+ incidente.NumeroIncidente + ",  Tipo: " + incidente.TipoIncidente + "<br/>";
                    })
                  }
                }
          return Contenido;
        },
        DetallesExternos(dato){
        let detalles =''
        detalles = detalles + 'Recibido por: '  + (dato.DetallesExternos.NombreReceptor!=null ? dato.DetallesExternos.NombreReceptor : '' ) + '<br>';
        
        switch (dato.AreaExterna.AreaExternaId)
        {
          case 1: 
          detalles = detalles + "<b>Notaría</b> No : " + (dato.DetallesExternos.Numero!=0 ? dato.DetallesExternos.Numero : '') + '<br>';
          break;
          case 2: 
          detalles = detalles + "<b>Juzgado de Distrito</b> No : " + (dato.DetallesExternos.Numero!=0 ? dato.DetallesExternos.Numero : '') + '<br>';
          break;
          case 4: 
          detalles = detalles + "<b>Tribunal Colegiado</b> No : " + (dato.DetallesExternos.Numero!=0 ? dato.DetallesExternos.Numero : '') + '<br>';
          break;
          case 5: 
          detalles = detalles + "<b>Ministerio Público</b> No : " + (dato.DetallesExternos.Numero!=0 ? dato.DetallesExternos.Numero : '') + '<br>';
          break;
          case 6: 
          detalles = detalles +  '<b>Supremo Tribunal </b><br>';
          break;
        }
        detalles = detalles  + 'Observaciones: ' + (dato.DetallesExternos.Observaciones!=null ? dato.DetallesExternos.Observaciones : '') + '<br>';
        detalles = detalles  + 'Fecha de Envío: ' + this.obtenFechaConFormato(dato.FechaMovimiento);
        return detalles;
        },
        DetallesUbicacionVolumen(dato, sede){ 
          let detalles ='';
          if(dato.Area.AreaId==21)
          {
              detalles = detalles + dato.Area.Nombre + '<br>';
              detalles = detalles + "Sede : " + sede.Nombre;
          }
          else
          {
              if(dato.MovimientoVolumen.AreaExterna!=null && dato.MovimientoVolumen.AreaExterna.AreaExternaId!=null)
              {
                  
                
                  switch (dato.MovimientoVolumen.AreaExterna.AreaExternaId)
                  {
                      case 1: 
                      detalles = detalles + "Notaría No : " + (dato.MovimientoVolumen.DetallesExternos!= null && dato.MovimientoVolumen.DetallesExternos.Numero!=0 ? dato.MovimientoVolumen.DetallesExternos.Numero : '') + '<br>';
                      break;
                      case 2: 
                      detalles = detalles + "Juzgado de Distrito No : " + (dato.MovimientoVolumen.DetallesExternos!= null && dato.MovimientoVolumen.DetallesExternos.Numero!=0 ? dato.MovimientoVolumen.DetallesExternos.Numero : '') + '<br>';
                      break;
                      case 4: 
                      detalles = detalles + "Tribunal Colegiado no : " + (dato.MovimientoVolumen.DetallesExternos!= null && dato.MovimientoVolumen.DetallesExternos.Numero!=0 ? dato.MovimientoVolumen.DetallesExternos.Numero : '') + '<br>';
                      break;
                      case 5: 
                      detalles = detalles + "Ministerio Público No : " + (dato.MovimientoVolumen.DetallesExternos!= null && dato.MovimientoVolumen.DetallesExternos.Numero!=0 ? dato.MovimientoVolumen.DetallesExternos.Numero : '') + '<br>';
                      break;
                  }
                  detalles = detalles + 'Recibido por: '  + (dato.MovimientoVolumen.DetallesExternos!= null && dato.MovimientoVolumen.DetallesExternos.NombreReceptor!=null ? dato.MovimientoVolumen.DetallesExternos.NombreReceptor : '' ) + '<br>';
                  detalles = detalles  + 'Observaciones: ' + (dato.MovimientoVolumen.DetallesExternos!= null && dato.MovimientoVolumen.DetallesExternos.Observaciones!=null ? dato.MovimientoVolumen.DetallesExternos.Observaciones : '') + '<br>';
                  detalles = detalles  + 'Fecha de Envío: ' + this.obtenFechaConFormato(dato.MovimientoVolumen.FechaMovimiento) + '<br>';;
                  if(dato.MovimientoVolumen.FechaRecepcion==null)
                  {
                    detalles = detalles  + 'Pendiente de recepción por : ' + dato.MovimientoVolumen.AreaQueRecibe.Nombre
                  }
              }
              else
              {
                  let nombreUsuario = '';
                  if(dato.MovimientoVolumen.FechaRecepcion==null)
                  {
                    detalles = detalles +  '<b class="text-primary">' + dato.MovimientoVolumen.AreaQuePresta.Nombre + '</b><br>';
                  }
                  else
                  {
                    detalles = detalles +  '<b class="text-primary">' + dato.Area.Nombre + '</b><br>';
                  }
                  if(dato.MovimientoVolumen.FechaRecepcion==null)
                  {
                    
                      if(dato.MovimientoVolumen.SolicitudDocumentoId!=null && dato.MovimientoVolumen.SolicitudDocumentoId!=undefined && dato.MovimientoVolumen.SolicitudDocumentoId!=0)
                      {
                          detalles = detalles + '<b class="text-danger">En proceso de Recepción por Autorización de Prestamo para : ' + dato.MovimientoVolumen.AreaQueRecibe.Nombre + '</b><br>';
                      }
                      else
                      {
                          detalles = detalles + '<b class="text-danger">En proceso de Recepción por : ' + dato.MovimientoVolumen.AreaQueRecibe.Nombre + '</b><br>';
                      }
                      
                  };
                  
                  if(dato.MovimientoVolumen.UsuarioQuienRecibe!=null)
                  {
                      if(dato.MovimientoVolumen.UsuarioQuienRecibe.IdUsuario==6)
                      {
                          nombreUsuario = "No Asignado"
                      }
                      else
                      {
                          nombreUsuario = dato.MovimientoVolumen.UsuarioQuienRecibe.Nombre + " " + dato.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno + " " + (dato.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno!=null ? dato.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno : "")
                      }
                  }
                  else
                  {
                      nombreUsuario = "No Asignado"
                  };
                  detalles = detalles + "Usuario : " + nombreUsuario+ '<br>';
                  detalles = detalles + 'Fecha de Envío :' + this.obtenFechaConFormato(dato.MovimientoVolumen.FechaMovimiento);
              }
          }
          return detalles;
        },
        DetallesUbicacionIncidente(dato, sede){
        console.log(dato)
        let detalles =''
        if(dato.Area.AreaId==21)
        {
            detalles = detalles +  dato.Area.Nombre + '<br>';
            detalles = detalles + "Sede : " + sede.Nombre;
        }
        else
        {
            if(dato.MovimientoIncidente.AreaExterna!=null && dato.MovimientoIncidente.AreaExterna.AreaExternaId!=null)
            {
                detalles = detalles + 'Recibido por: '  + (dato.MovimientoIncidente.DetallesExternos!=null && dato.MovimientoIncidente.DetallesExternos.NombreReceptor!=null ? dato.MovimientoIncidente.DetallesExternos.NombreReceptor : '' ) + '<br>';
        
                switch (dato.MovimientoIncidente.AreaExterna.AreaExternaId)
                {
                    case 1: 
                    detalles = detalles + "Notaría No : " + (dato.MovimientoIncidente.DetallesExternos!=null && dato.MovimientoIncidente.DetallesExternos.Numero!=0 ? dato.MovimientoIncidente.DetallesExternos.Numero : '') + '<br>';
                    break;
                    case 2: 
                    detalles = detalles + "Juzgado de Distrito No : " + (dato.MovimientoIncidente.DetallesExternos!=null && dato.MovimientoIncidente.DetallesExternos.Numero!=0 ? dato.MovimientoIncidente.DetallesExternos.Numero : '') + '<br>';
                    break;
                    case 4: 
                    detalles = detalles + "Tribunal Colegiado no : " + (dato.MovimientoIncidente.DetallesExternos!=null && dato.MovimientoIncidente.DetallesExternos.Numero!=0 ? dato.MovimientoIncidente.DetallesExternos.Numero : '') + '<br>';
                    break;
                    case 5: 
                    detalles = detalles + "Ministerio Público No : " + (dato.MovimientoIncidente.DetallesExternos!=null && dato.MovimientoIncidente.DetallesExternos.Numero!=0 ? dato.MovimientoIncidente.DetallesExternos.Numero : '') + '<br>';
                    break;
                }
                detalles = detalles  + 'Observaciones: ' + (dato.MovimientoIncidente.DetallesExternos!=null && dato.MovimientoIncidente.DetallesExternos.Observaciones!=null ? dato.MovimientoIncidente.DetallesExternos.Observaciones : '') + '<br>';
                detalles = detalles  + 'Fecha de Envío: ' + this.obtenFechaConFormato(dato.MovimientoIncidente.FechaMovimiento);
            }
            else
            {
                let nombreUsuario = '';
                if(dato.MovimientoIncidente.FechaRecepcion==null)
                {
                  detalles = detalles +  '<b class="text-primary">' + dato.MovimientoIncidente.AreaQuePresta.Nombre + '</b><br>';
                }
                else
                {
                  detalles = detalles +  '<b class="text-primary">' + dato.Area.Nombre + '</b><br>';
                }
                if(dato.MovimientoIncidente.FechaRecepcion==null)
                {
                    detalles = detalles + '<b class="text-danger">En proceso de Recepción por: ' + dato.MovimientoIncidente.AreaQueRecibe.Nombre + '</b><br>';
                };
                if(dato.MovimientoIncidente.UsuarioQuienRecibe!=null)
                {
                    if(dato.MovimientoIncidente.UsuarioQuienRecibe.IdUsuario==6)
                    {
                        nombreUsuario = "No Asignado"
                    }
                    else
                    {
                        nombreUsuario = dato.MovimientoIncidente.UsuarioQuienRecibe.Nombre + " " + dato.MovimientoIncidente.UsuarioQuienRecibe.ApellidoPaterno + " " + (dato.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno!=null ? dato.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno : "")
                    }
                }
                else
                {
                    nombreUsuario = "No Asignado"
                }
                detalles = detalles + "Usuario : " + nombreUsuario + '<br>';
                detalles = detalles + 'Fecha de Envío :' + this.obtenFechaConFormato(dato.MovimientoIncidente.FechaMovimiento)
            }
        }
        return detalles;
        },
        DetallesUbicacionTerceria(dato, sede){
        let detalles =''
        if(dato.Area.AreaId==21)
        {
            detalles = detalles + dato.Area.Nombre + '<br>';
            detalles = detalles + "Sede : &nbsp" + sede.Nombre;
        }
        else
        {
            if(dato.MovimientoTerceria.AreaExterna!=null && dato.MovimientoTerceria.AreaExterna.AreaExternaId!=null)
            {
                detalles = detalles + 'Recibido por: &nbsp'  + (dato.MovimientoTerceria.DetallesExternos.NombreReceptor!=null ? dato.MovimientoTerceria.DetallesExternos.NombreReceptor : '' ) + '<br>';
        
                switch (dato.MovimientoTerceria.AreaExterna.AreaExternaId)
                {
                    case 1: 
                    detalles = detalles + "Notaría No : &nbsp" + (dato.MovimientoTerceria.DetallesExternos.Numero!=0 ? dato.MovimientoTerceria.DetallesExternos.Numero : '') + '<br>';
                    break;
                    case 2: 
                    detalles = detalles + "Juzgado de Distrito No : &nbsp" + (dato.MovimientoTerceria.DetallesExternos.Numero!=0 ? dato.MovimientoTerceria.DetallesExternos.Numero : '') + '<br>';
                    break;
                    case 4: 
                    detalles = detalles + "Tribunal Colegiado no : &nbsp" + (dato.MovimientoTerceria.DetallesExternos.Numero!=0 ? dato.MovimientoTerceria.DetallesExternos.Numero : '') + '<br>';
                    break;
                    case 5: 
                    detalles = detalles + "Ministerio Público No : &nbsp " + (dato.MovimientoTerceria.DetallesExternos.Numero!=0 ? dato.MovimientoTerceria.DetallesExternos.Numero : '') + '<br>';
                    break;
                }
                detalles = detalles  + 'Observaciones: &nbsp' + (dato.MovimientoTerceria.DetallesExternos.Observaciones!=null ? dato.MovimientoTerceria.DetallesExternos.Observaciones : '') + '<br>';
                detalles = detalles  + 'Fecha de Envío: &nbsp' + this.obtenFechaConFormato(dato.MovimientoTerceria.FechaMovimiento);
            }
            else
            {
              let nombreUsuario = '';
                if(dato.MovimientoTerceria.FechaRecepcion==null)
                {
                  detalles = detalles +  '<b class="text-primary">' + dato.MovimientoTerceria.AreaQuePresta.Nombre + '</b><br>';
                }
                else
                {
                  detalles = detalles +  '<b class="text-primary">' + dato.Area.Nombre + '</b><br>';
                }
                if(dato.MovimientoTerceria.FechaRecepcion==null)
                {
                    detalles = detalles + '<b class="text-danger">En proceso de Recepción por: ' + dato.MovimientoTerceria.AreaQueRecibe.Nombre + '</b><br>';
                };
                if(dato.MovimientoTerceria.UsuarioQuienRecibe!=null)
                {
                    if(dato.MovimientoTerceria.UsuarioQuienRecibe.IdUsuario==6)
                    {
                        nombreUsuario = "No Asignado"
                    }
                    else
                    {
                        nombreUsuario = dato.MovimientoTerceria.UsuarioQuienRecibe.Nombre + " " + dato.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno + " " + (dato.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno!=null ? dato.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno : "")
                    }
                }
                else
                {
                    nombreUsuario = "No Asignado"
                }
                detalles = detalles + "Usuario : &nbsp" + nombreUsuario + '<br>';
                detalles = detalles + 'Fecha de Envío : '  + this.obtenFechaConFormato(dato.MovimientoTerceria.FechaMovimiento)
            }
        }
        return detalles;
        },
        AlertaRecepcion: function(datos)
        {
          console.log(datos)
          let arrayTemporal = [];
          if(datos!=null)
          {
            if(datos[0].MovimientoVolumen!=null)
            {
              if(datos[0].MovimientoVolumen.FechaRecepcion==null)
              {
                arrayTemporal.push({
                  Ubicacion: datos[0].MovimientoVolumen.AreaQuePresta!= null ? (datos[0].MovimientoVolumen.AreaQuePresta.Nombre) : (datos[0].MovimientoVolumen.AreaExterna!=null ? datos[0].MovimientoVolumen.AreaExterna.Nombre : ''),
                  Destino: datos[0].MovimientoVolumen.AreaQueRecibe.Nombre,
                  FechaEnvio : this.obtenFechaConFormato(datos[0].MovimientoVolumen.FechaMovimiento)
                })
              }
            }
          }
          return arrayTemporal;
        }
    },
    mounted(){
      var AreaUsuario = this.$store.state.Login_Usuario;
      if(AreaUsuario.Area.AreaId==95)
      {
        comun.mensajeDeAlerta("Para la Consulta de Expedientes del Juzgado de Ejecución de Penas y Medidas de Seguridad anteriores al año 2021, debera completarse el Sufijo en Numero Romano de acuerdo a su procedencia:" 
                + "</br>I   .- Juzgado Primero de Ejecución."
                + "</br>II  .- Juzgado Segundo de Ejecución."
                + "</br>III .- Unidad de Gestión"
                + "</br>Por Codigo de Barras 42xxxXXXXxxxx + Sufijo.", null, null);
      }
    }
}
</script>
<style scoped>
  input[type="text"]:read-only {
    background: #f3f3f3;
  }
  input[type="text"]:read-only:focus {
    color: #fff;
  }
  .thead-custom {
    background-color: #004746;
    color: white;
  }
  .custom-area {
      background-color: #7e7f74;
  }
  .label-black {
      color: black;
  }
  .btn-custom {
    background-color: #004746;
    color: white;
  }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Inventario/AgregarReferencia.vue